

//   document.querySelectorAll('fieldset.variant-picker__option')
// .forEach(f=>f.querySelector('legend')?.textContent.includes('Color')&&f.remove())


(function() {
  function isMobile() {
    return window.innerWidth < 768;
  }

  function bindZoomOnImages() {
    var images = document.querySelectorAll('.product-gallery__image-list img, .product-gallery [data-index] img');

    images.forEach(function(img) {
      img.style.cursor = isMobile() ? 'zoom-in' : '';

      img.addEventListener('click', function(e) {
        if (!isMobile()) return;

        // Find the zoom button within the same gallery
        var gallery = img.closest('product-gallery') || document.querySelector('product-gallery');
        var zoomBtn = gallery ? gallery.querySelector('.product-gallery__zoom-button') : document.querySelector('.product-gallery__zoom-button');

        if (zoomBtn) {
          zoomBtn.click();
        }
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function() {
    bindZoomOnImages();
  });
})();